import styled from "@emotion/styled";
import {
  EXAMPLE_SCENARIO_BACKGROUND_COLOR_GRADIENT,
  COLOR_APP_TEXT,
  IconSize,
  MOBILE_SCREEN,
} from "../../components/theme";
import { ParagraphHeaderSmall } from "../../components/typography/Paragraph";
import { StyledDescription } from "./Questionnaire";
import File from "../../components/icons/FileWithContent";

const StyledExampleScenario = styled.div`
  background: ${EXAMPLE_SCENARIO_BACKGROUND_COLOR_GRADIENT};
  padding: 24px;
  border-radius: 16px;
  margin: 24px 0;
  ${MOBILE_SCREEN} {
    margin: 8px 0;
  }
`;

const StyledExampleScenarioHeader = styled.div`
  display: flex;
  gap: 8px;
`;

interface ExampleScenarioProps {
  text: string;
}

const ExampleScenario: React.FC<ExampleScenarioProps> = ({ text }) => {
  if (!text || text.length === 0) return null;
  return (
    <StyledExampleScenario>
      <StyledExampleScenarioHeader>
        <File size={IconSize.M} />
        <ParagraphHeaderSmall color={COLOR_APP_TEXT} fontWeight={700}>
          Example Scenario:
        </ParagraphHeaderSmall>
      </StyledExampleScenarioHeader>
      <StyledDescription dangerouslySetInnerHTML={{ __html: text }} />
    </StyledExampleScenario>
  );
};

export default ExampleScenario;
